/**
 * hasat.market Design-v2.1 Global Video & Interaction Engine
 */
(function() {
  function initVideoHover() {
    document.addEventListener('mouseover', function(e) {
      const card = e.target.closest('.hasat-product-card');
      if (card) {
        const video = card.querySelector('.hasat-product-card__video');
        if (video && video.paused) {
          video.play().catch(function() {});
        }
      }
    });

    document.addEventListener('mouseout', function(e) {
      const card = e.target.closest('.hasat-product-card');
      if (card && (!e.relatedTarget || !card.contains(e.relatedTarget))) {
        const video = card.querySelector('.hasat-product-card__video');
        if (video && !video.paused) {
          video.pause();
        }
      }
    });
  }

  function initPdpVideo() {
    const pdpVideo = document.getElementById('hasat-pdp-video-player');
    if (pdpVideo) {
      pdpVideo.muted = true;
      pdpVideo.defaultMuted = true;
      pdpVideo.setAttribute('muted', '');
      pdpVideo.setAttribute('playsinline', '');
      pdpVideo.setAttribute('webkit-playsinline', '');
      pdpVideo.setAttribute('autoplay', '');
      pdpVideo.setAttribute('loop', '');

      function attemptPlay() {
        const videoView = document.getElementById('hasat-pdp-video-view');
        if (!videoView || window.getComputedStyle(videoView).display !== 'none') {
          const p = pdpVideo.play();
          if (p && typeof p.catch === 'function') {
            p.catch(function() {
              // If browser requires user interaction first, resume on first interaction
              const resumeOnInteraction = function() {
                pdpVideo.play().catch(function() {});
                window.removeEventListener('click', resumeOnInteraction);
                window.removeEventListener('touchstart', resumeOnInteraction);
                window.removeEventListener('scroll', resumeOnInteraction);
              };
              window.addEventListener('click', resumeOnInteraction, { once: true, passive: true });
              window.addEventListener('touchstart', resumeOnInteraction, { once: true, passive: true });
              window.addEventListener('scroll', resumeOnInteraction, { once: true, passive: true });
            });
          }
        }
      }

      pdpVideo.addEventListener('loadedmetadata', attemptPlay);
      pdpVideo.addEventListener('canplay', attemptPlay);
      attemptPlay();
    }
  }

  function initLazyVideos() {
    const lazyVideos = document.querySelectorAll('.hasat-lazy-video');
    if (!lazyVideos.length || !('IntersectionObserver' in window)) return;

    const videoObserver = new IntersectionObserver(function(entries) {
      entries.forEach(function(entry) {
        const video = entry.target;
        if (entry.isIntersecting) {
          if (video.paused) {
            video.play().catch(function() {});
          }
        } else {
          if (!video.paused) {
            video.pause();
          }
        }
      });
    }, { rootMargin: '100px 0px', threshold: 0.1 });

    lazyVideos.forEach(function(video) {
      videoObserver.observe(video);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function() {
      initVideoHover();
      initPdpVideo();
      initLazyVideos();
    });
  } else {
    initVideoHover();
    initPdpVideo();
    initLazyVideos();
  }
})();
